import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../shared/service/common.service';
import { AboutUs } from '../shared/model/AboutUs';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';
@Component({
  selector: 'app-admin-about',
  templateUrl: './admin-about.component.html',
  styleUrls: ['./admin-about.component.css']
})

export class AdminAboutComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  LocalToken: string = '';

  aboutUsObj: AboutUs = {
    Id: null,
    Description: "",
  }

  constructor(private CommonService: CommonService, private router: Router, private autoLogoutService: AutoLogoutService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
  }

  ngOnInit() {
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getAboutUs();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }
  }

  getAboutUs() {
    this.CommonService
      .getAboutUs()
      .then((result) => {
        this.aboutUsObj.Id = result[0].Id;
        this.aboutUsObj.Description = result[0].Description;
      })
      .catch((err) => console.log(err));
  }

  editAboutUs() {
    this.blockUI.start('Please wait...');
    this.CommonService
      .editAboutUs(this.aboutUsObj)
      .then((result) => {
        this.blockUI.stop();
        //console.log("Success");
      })
      .catch((err) => console.log(err));
  }
}
